import * as React from 'react';
import QuestionPopover from './QuestionPopover';
import {
    Translation
} from '../../features/translations/getTranslation'

export const BasicLabel = (props: any) => (
    <label style={{ ...props.style }}>{Translation.t(props.text)}</label>
);

export const Label = (props: any) => (
    <label style={{ fontWeight: 600, marginTop: '0.5rem', marginBottom: '0.5rem', ...props.style }}>{Translation.t(props.text)}</label>
);

export const SectionLabel = (props: any) => (
    <h5 style={{ fontWeight: 600, marginTop: '0.5rem', marginBottom: '0.5rem', backgroundColor: 'lightgray', padding: '5px' }}>{Translation.t(props.text)}</h5>
);

export const SectionWithQuestionLabel = (props: any) => (
    <div style={{ width: 'calc(100% - 10px)', fontWeight: 600, marginTop: '0.5rem', marginBottom: '0.5rem', backgroundColor: 'lightgray', padding: '5px', display: 'inline-flex', justifyContent: 'space-between' }}>
        <h5>{Translation.t(props.text)}</h5>
        <span style={{ width: '50px' }}><QuestionPopover text={Translation.t(props.questionText)}></QuestionPopover></span>
    </div>
);

export default Label;